<template>
  <div class="p-3 custom-bg mt-3">
    <validation-observer ref="addContractObserver" v-slot="{ validate, reset }">
      <div class="row">
        <div class="col-12">
          <label class="font-weight-bolder">Añadir otro Contrato</label>
        </div>
        <div class="col-3 my-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.provider"
              :clearable="true"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Proveedor"
              :options="contractors"
            />
          </ValidationProvider>
        </div>

        <div class="col-3 my-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.contractNumber"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Número de Contrato"
              placeholder="Número de Contrato"
            />
          </validation-provider>
        </div>

        <div class="col-3 my-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.currentAmount"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Cuantía del Contrato Vigente"
              mask-type="Money"
              placeholder="Cuantía del Contrato Vigente"
            />
          </validation-provider>
        </div>

        <div class="col-3 my-3">
          <validation-provider v-slot="{ errors }" rules="required|min_value:0">
            <custom-input
              v-model="model.amendmentsGranted"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Enmiendas previamente otorgadas"
              :min="0"
              placeholder="Enmiendas previamente otorgadas"
              type="number"
            />
          </validation-provider>
        </div>

        <div class="col-12 d-flex justify-content-end my-3">
          <action-button
            class="mr-2 px-3"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger"
            @click="onCancel(reset)"
          />
          <action-button
            class="mr-2 px-3"
            i="fas fa-file-plus"
            text="Añadir"
            variant="success"
            @click="onSubmit(validate, reset)"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
// components
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import ActionButton from 'ActionButton';
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'AddContract',
  components: { ActionButton, CustomInput, CustomDropDown },
  mixins: [alertMixin],
  props: {
    isReadOnly: { type: Boolean, default: () => false },
    contractors: { type: Array, default: () => [] },
  },
  data() {
    return {
      model: {
        provider: null,
        contractNumber: '',
        currentAmount: null,
        amendmentsGranted: null,
      },
    };
  },
  methods: {
    getAmendmentLetter(number) {
      return String.fromCharCode(64 + (number % 26));
    },
    async onSubmit(validate, reset) {
      const ok = await validate();
      if (!ok) return;

      const payload = {
        providerName: this.model.provider?.name || '',
        contractNumber: this.model.contractNumber,
        amount: this.model.currentAmount,
        quantity: Number(this.model.amendmentsGranted),
        lastAmendmentCode:
          Number(this.model.amendmentsGranted) == 0
            ? null
            : this.getAmendmentLetter(Number(this.model.amendmentsGranted)),
      };

      this.$emit('add', payload);
      reset?.();
      this.resetModel();
    },
    onCancel(reset) {
      reset?.();
      this.resetModel();
      this.$emit('cancel');
    },
    resetModel() {
      this.model = {
        contractNumber: '',
        currentAmount: null,
        amendmentsGranted: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-bg {
  background-color: #fafafa;
}
</style>
